angular.module('picmonic-common').factory('ResourcesResource', [
  '$resource',
  function ($resource) {
    return $resource(
      '/api/v3/resources',
      {},
      {
        update: { method: 'PUT', isArray: false },
      }
    );
  },
]);
